import app from 'firebase/app';
import { createTransfer } from './stripe';

const getUserCollection = () => app.firestore().collection('users');

export const getUserByUid = uid => {
    let docRef = getUserCollection().doc(uid);
    return docRef
        .get()
        .then(function (doc) {
            if (doc.exists) {
                return doc.data();
            } else {
                console.log('No such document!');
            }
        })
        .catch(function (error) {
            console.log('Error getting document:', error);
        });
};

export const getUserByInviteCode = inviteCode => {
    let docRef = getUserCollection().where('inviteCode', '==', inviteCode);
    return docRef.get().then(result => {
        if (!result.empty) {
            return result.docs;
        }
    });
};

export const createUser = (uid, user) => {
    getUserCollection()
        .doc(uid)
        .set({ ...user });
    return getUserByUid(uid);
};

export const updateUser = dto => {
    return new Promise(function (resolve, reject) {
        const docRef = getUserCollection().doc(dto.uid);
        docRef.update({ ...dto });
        if (docRef && docRef.id) {
            resolve(docRef.id);
        } else {
            reject('Object not updated');
        }
    });
};

export const updateUsersAfterPayment = async ({
    recipientId,
    senderId,
    amount,
    pendingPayments = [],
}) => {
    const recipient = await getUserByUid(recipientId);
    const sender = await getUserByUid(senderId);

    recipient.earned = (recipient.earned || 0) + amount;
    sender.donated = (sender.donated || 0) + amount;

    return Promise.all([
        updateUser({
            ...recipient,
            pendingPayments: [...(recipient.pendingPayments || []), ...pendingPayments],
        }),
        updateUser(sender),
    ]);
};

export const getUserPendingPayments = async uid => {
    const userSnap = await getUserCollection().doc(uid).get();
    const user = userSnap.data();

    return user.pendingPayments ? user.pendingPayments : [];
};

export const checkPendingTransactions = async uid => {
    const userSnap = await getUserCollection().doc(uid).get();
    const user = userSnap.data();

    const transactionDocs = await Promise.all(
        (user.pendingPayments || []).map(pp =>
            app
                .firestore()
                .collection('transactions')
                .where('id', '==', pp.id)
                .where('isCompleted', '==', true)
                .get()
                .then(snap => snap.docs)
        )
    );

    const transactions = Array.prototype.concat.apply([], transactionDocs);
    console.log(transactions);

    for (let transaction of transactions) {
        const pendingPayment = user.pendingPayments.find(pp => pp.id === transaction.id);

        await createTransfer({
            amount: pendingPayment.amount - pendingPayment.feeAmount,
            transferGroup: pendingPayment.transferGroup,
            destination: user.stripeUserId,
            userId: user.uid,
        });
    }
};
